export default "__VITE_ASSET__B0_zwMMs__"